export const TRACKING_PARAM_KEYS = [
  'gclid',
  'gbraid',
  'wbraid',
  'hubspotutk',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
];

const storageKey = (key) => `pe_tracking_${key}`;

export function captureTrackingParams() {
  try {
    const params = new URLSearchParams(window.location.search);
    TRACKING_PARAM_KEYS.forEach((key) => {
      const value = params.get(key);
      if (value) sessionStorage.setItem(storageKey(key), value);
    });
  } catch (e) {
    // sessionStorage unavailable (private mode, blocked storage) — tracking is best effort
  }
}

export function getTrackingParam(key) {
  try {
    const fromUrl = new URLSearchParams(window.location.search).get(key);
    if (fromUrl) return fromUrl;
    return sessionStorage.getItem(storageKey(key));
  } catch (e) {
    return null;
  }
}

export function trackingParams() {
  const result = {};
  TRACKING_PARAM_KEYS.forEach((key) => {
    const value = getTrackingParam(key);
    if (value) result[key] = value;
  });
  return result;
}

export function withTrackingParams(url) {
  try {
    const target = new URL(url, window.location.origin);
    Object.entries(trackingParams()).forEach(([key, value]) => {
      if (!target.searchParams.get(key)) target.searchParams.set(key, value);
    });
    return /^https?:/i.test(url)
      ? target.toString()
      : target.pathname + target.search + target.hash;
  } catch (e) {
    return url;
  }
}

export function trackingSearch() {
  const query = new URLSearchParams(trackingParams()).toString();
  return query ? `?${query}` : '';
}
